import * as React from "react";
import { Header } from "../organisms/common/header";
import { SandboxAlert } from "../organisms/common/sandbox-alert";
import { emptyFunction } from "../../utils/function-utils";

export const BrowserTemplate: React.FC<{
  children: React.ReactNode;
  title: string;
}> = (props) => (
  <div className="c-content-wrapper">
    <SandboxAlert />
    {props.title === "スマート申請" || props.title === "ヘルプ" ? (
      <></>
    ) : (
      <Header title={props.title} onLogoClick={emptyFunction} /> // TODO: 新デザインでNavigationでラップしてHeaderを表示するので、ここでは表示しない。（一旦スマート申請のみ）移行後に削除する。
    )}
    {props.children}
  </div>
);
